module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalConfirmation', {
    attrs: {
      "showClose": false,
      "isSubmitButtonLoading": _vm.isSubmitting,
      "isShowConfirmDeleteMessage": false
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      },
      "confirm": _vm.onConfirmAwayStatus
    }
  }, [_c('div', {
    attrs: {
      "slot": "custom_warning"
    },
    slot: "custom_warning"
  }, [(!_vm.isAway) ? [_c('h4', [_vm._v(_vm._s(_vm.i18n.confirm_away_title))]), _vm._v(" "), _c('p', {
    staticClass: "pad-1 italic pad-0-top"
  }, [_vm._v(_vm._s(_vm.i18n.confirm_away_text))])] : [_c('h4', [_vm._v(_vm._s(_vm.i18n.confirm_unaway_title))]), _vm._v(" "), _c('p', {
    staticClass: "pad-1 italic"
  }, [_vm._v(_vm._s(_vm.i18n.confirm_unaway_text))])]], 2), _vm._v(" "), _c('p', {
    attrs: {
      "slot": "confirmText"
    },
    slot: "confirmText"
  }, [_vm._v(_vm._s(!_vm.isAway ? _vm.i18n.mark_as_away : _vm.i18n.unmark_as_away))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a895afee!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Events/DModalOutOfSchoolLesson.vue
// module id = 1718
// module chunks = 1